
import { Component, Mixins } from 'vue-property-decorator';
import { PermissionCode } from '@/types';
import moment from 'moment';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationEneaPractice extends Mixins(OperationComponentMixin) {
  loading = false
  editDialog = false

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  get isDisabled() {
    return this.loading || !this.hasPermission('eneaPracticeDate.edit');
  }

  get tooltipColor(): string {
    return '';
  }

  get tooltipText(): string {
    return 'Data pratica ENEA/GSE/Altro';
  }

  get eneaPracticeDate(): Date | null {
    return this.operationChild?.eneaPracticeDate ?? this.operation.eneaPracticeDate ?? null;
  }

  get praticaEnea(): string {
    return this.operationChild?.praticaEnea ?? this.operation.praticaEnea ?? '';
  }

  get eneaPracticeDateString(): string | null {
    if (this.praticaEnea === 'na') return 'Non applicabile';
    return this.eneaPracticeDate
      && moment(this.eneaPracticeDate).isValid()
      ? moment(this.eneaPracticeDate).format('L')
      : null;
  }

  get linkClass(): string {
    // Se è disabilitato, ritorna il colore grigio senza puntatore
    if (this.isDisabled) return 'grey--text text--lighten-2';
    // Se la pratica ENEA è 'na', ritorna il colore grigio con puntatore
    if (this.praticaEnea === 'na') return 'link grey--text text--darken-2';

    // Se la data non è definita, ritorna il colore grigio con puntatore
    return this.eneaPracticeDateString
      ? 'link'
      : 'link grey--text text--lighten-2';
  }

  get columnClass(): string {
    if (this.praticaEnea === 'na') return 'grey lighten-3';
    if (this.eneaPracticeDate && this.praticaEnea === 'done') return 'green';
    return '';
  }

  onEdit() {
    console.log('OperationEneaPractice: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
